<template>
  <div v-if="media.length" class="w-chat__gallery" :class="{ 'alert-danger': fullWidth }">
    <div class="members__grid">
      <div v-for="image in media" v-bind:key="image.id" @click="send(image.id)" class="members__profile">
        <div v-if="image.price" class="profile-edit__photo profile-edit__photo--price" v-bind:style="{ 'background-image': 'url(' + image.url + ')' }">
          <div class="profile-edit__photo-price">{{ image.price }} <i class="demo-icon icon-n-lova-coins"></i></div>
        </div>
        <div v-else class="profile-edit__photo" v-bind:style="{ 'background-image': 'url(' + image.url + ') ' }"></div>
      </div>
    </div>
  </div>
  <div class="pb-2" v-else>
    <div class="w-100 text-center w-chat__gallery--empty">
      <div class="w-chat__gallery--empty-title">
        {{ trans.get('pages:chat.image_gallery.empty_title') }}
      </div>

      <a class="button button__tight button__outline mb-4" :href="zRoute('front.profile.edit')">
        {{ trans.get('pages:chat.image_gallery.empty_button') }}
      </a>
    </div>
  </div>
</template>

<script>
import ImageGalleryMixin from '../../../front/components/Chat/ImageGalleryMixin';

export default {
  name: 'ImageGallery',
  mixins: [ImageGalleryMixin],
  components: {},
  props: {
    fullWidth: {},
  },
};
</script>
